"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWebSocketConfig = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const getWebSocketConfig = (progressId, accessToken) => ({
    url: `${window.WEBSOCKET_DOMAIN_URL}/?accessToken=${accessToken}`,
    request: {
        id: (0, web_ui_framework_1.createUUID)(),
        service: 'mb-authorization-service',
        eventType: 'GetChallengeInfo',
        endpoint: '/v1/authorize/websocket/challenge-info',
        detail: {
            headers: {
                accessToken,
                applicationLocale: 'en-US',
                bankId: 'SB_US',
                appInfo: 'ModelBank-1.500',
            },
            payload: {
                progressId,
            },
        },
    },
});
exports.getWebSocketConfig = getWebSocketConfig;
//# sourceMappingURL=websocket.helper.js.map